import {useGlobalContext} from '@/lib/context/global';

export const useIsSandboxMode = () => {
    const {isSandbox} = useGlobalContext();
    return isSandbox;
};
